import { lazy } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'

const LoginPage = lazy(() => import('./pages/LoginPage'))
const MainLayout = lazy(() => import('./layouts/MainLayout'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const AudioManagement = lazy(() => import('./pages/AudioManagement'))
const AIStudio = lazy(() => import('./pages/AIStudio'))
const CategoryManagement = lazy(() => import('./pages/CategoryManagement'))
const UserManagement = lazy(() => import('./pages/UserManagement'))
const Settings = lazy(() => import('./pages/Settings'))

export const routes = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'content/audios',
        element: <AudioManagement />,
      },
      {
        path: 'content/categories',
        element: <CategoryManagement />,
      },
      {
        path: 'ai-studio',
        element: <AIStudio />,
      },
      {
        path: 'users',
        element: <UserManagement />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
    ],
  },
]

export function Router() {
  return useRoutes(routes)
}
